// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16yRK","col":"styles_col__2PNCt"};